interface BrandMarkProps {
  width?: number;
  /** Render the two upper bars in the muted tone (footer treatment). */
  muted?: boolean;
}

/**
 * The TLDR mark: three stacked bars of decreasing length, the shortest one
 * carrying the accent. Same geometry as the favicon.
 */
export function BrandMark({ width = 18, muted = false }: BrandMarkProps) {
  const barFill = muted ? 'var(--faint)' : 'var(--ink)';
  return (
    <svg
      className="brand-mark"
      width={width}
      height={(width * 14.8) / 18}
      viewBox="0 0 18 14.8"
      fill="none"
      aria-hidden="true"
    >
      <rect x="0" y="0" width="18" height="3.6" rx="1.8" fill={barFill} />
      <rect x="0" y="5.6" width="12" height="3.6" rx="1.8" fill={barFill} />
      <rect x="0" y="11.2" width="7" height="3.6" rx="1.8" fill="#6366f1" />
    </svg>
  );
}
